export class Base64Converter {
	static decode(str) {
		if (!str) return str;
		try {
			const decoded = atob(str);
			return decodeURIComponent(decoded.split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		} catch (e) {
			return str;
		}
	}

	static encode(str) {
		if (!str) return str;
		try {
			const encoded = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode('0x' + p1);
				});
			return btoa(encoded);
		} catch (e) {
			return str;
		}
	}

	static isBase64(str) {
		if (!str || typeof str !== 'string') return false;
		try {
			return btoa(atob(str)) === str;
		} catch (e) {
			return false;
		}
	}

	static smartDecode(str) {
		if (!str) return { decoded: str, encoding: 'none' };

		if (this.isBase64(str)) {
			const decoded = this.decode(str);
			if (decoded !== str) {
				return { decoded, encoding: 'base64' };
			}
		}

		try {
			const urlDecoded = decodeURIComponent(str);
			if (urlDecoded !== str) {
				return { decoded: urlDecoded, encoding: 'url' };
			}
		} catch (e) {
		}

		return { decoded: str, encoding: 'none' };
	}
}